require("./global.scss");
require("./fonts.scss");
const React = require("react");

const Provider = require("./src/components/ContextProvider");

module.exports.wrapRootElement = ({ element }) => {
  return <Provider.default>{element}</Provider.default>;
};
